module.exports = __webpack_public_path__ + "static/assets/6bc7ead0d280fbb1212e19e0126bf098.png";